// extracted by mini-css-extract-plugin
module.exports = {"Items":"_3MaUY","Item":"_1aF11","Name":"ogzKl","Image":"_1EQJs","CtaBlock":"_1WdAG"};